import { useEffect, useState } from "react";
import Button from "../../../Custom/Button/Button";
import styles from "./styles";
import EvidencijeObrazac2Dodavanje from "./EvidencijeObrazac2Dodavanje";
import { useGlobalContext } from "../../../../Context/Context";
import axios from "axios";

const SIGNATURE_URL = "https://data.nadzor.app/potpis.jpg";

// Definisan cs stil kao u Obrascu 1
const cs = {
  border: "1px solid black",
  padding: "4px",
  textAlign: "center",
  verticalAlign: "middle",
  fontSize: "14px",
};

function EvidencijeObrazac2() {
  const [data, setData] = useState([]);
  const [isDodavanje, setIsDodavanje] = useState(false);
  const [companyHeader, setCompanyHeader] = useState({
    name: "",
    address: "",
    pib: ""
  });

  const { selectedMainEntity, baseUrl, loggedUser, apiKey } = useGlobalContext();

  const fetchHeaderData = async () => {
    const id = selectedMainEntity?.company_id || selectedMainEntity?.id;
    if (!id || !loggedUser?.id) return;

    try {
      const { data: res } = await axios.post(
        `${baseUrl}/companies/readCompanyDetails.php`,
        { 
          user_id: loggedUser.id,
          api_key: apiKey,
          company_id: id
        }
      );
      if (res.status === 200) {
        setCompanyHeader({
          name: res.data.company_name,
          address: res.data.company_address,
          pib: res.data.pib
        });
      }
    } catch (e) {
      console.error("Error fetching header info:", e);
    }
  };

  const fetchData = async () => {
    const id = selectedMainEntity?.company_id || selectedMainEntity?.id;
    try {
      const { data: res } = await axios.post(
        `${baseUrl}/evidencija2/read.php`,
        { company_id: id }
      );
      if (res.status === 200) setData(res.data);
    } catch (e) {
      console.error("Greška:", e);
    }
  };

  useEffect(() => {
    if (selectedMainEntity) {
      fetchHeaderData();
      fetchData();
    }
  }, [selectedMainEntity]);

  const handleStampaj = async () => {
    const el = document.getElementById("print-obrazac2");
    if (!el) return;

    const useSignature = window.confirm("Da li želite da dodate stranicu sa potpisom?");
    let signatureHtml = "";
    if (useSignature) {
      signatureHtml = `<div style="page-break-before:always;"><div style="width:287mm;height:200mm;margin:0 auto;position:relative;background:#fff;"><img src="${SIGNATURE_URL}" style="position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);"/></div></div>`;
    }

    const printWindow = window.open("", "_blank");
    if (!printWindow) { alert("Popup blokiran."); return; }

    printWindow.document.write(`
      <html><head><meta charset="utf-8"/>
      <style>
        @page { size: A4 landscape; margin: 5mm; }
        body { margin:0; padding:5mm; font-family:sans-serif; font-size:11px; }
        table { width:100%; border-collapse:collapse; }
        td, th { border:1px solid black; padding:3px; text-align: center; vertical-align:middle; font-size:11px; }
        hr { width:80%; margin:0 auto 5px; border:0; border-top:1px solid black; }
      </style></head>
      <body>${el.innerHTML}${signatureHtml}</body></html>
    `);
    printWindow.document.close();
    printWindow.onload = () => { printWindow.focus(); printWindow.print(); printWindow.close(); };
  };

  return (
    <>
      {/* Dodat media print stil za uniformnost */}
      <style>{`
        @media print {
          @page { size: A4 landscape; margin: 5mm; }
          body * { visibility: hidden; }
          #print-obrazac2, #print-obrazac2 * { visibility: visible !important; }
          #print-obrazac2 { position:absolute !important; top:0 !important; left:0 !important; width:100% !important; }
          #print-obrazac2 table { width:100% !important; border-collapse:collapse !important; }
          #print-obrazac2 td, #print-obrazac2 th { border:1px solid black !important; padding:3px !important; font-size:11px !important; }
        }
      `}</style>

      <div style={{ fontSize: "14px", height: "100%", width: "100%", backgroundColor: "rgb(204,204,204)" }}>
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" }}>

          <div
            id="print-obrazac2"
            style={{ overflowY: "auto", backgroundColor: "white", padding: "40px", border: "1.5px solid #9f9f9f", height: "100%" }}
          >
            <div style={{ fontWeight: "bold", textAlign: "center", marginBottom: "20px" }}>
              <div>Образац 2</div>
              <div>ЕВИДЕНЦИЈА О ПОВРЕДАМА НА РАДУ</div>
            </div>

            <div style={{ display: "flex", marginBottom: "20px" }}>
              <div style={{ width: "33%", textAlign: "center" }}>
                {companyHeader.name || selectedMainEntity?.company_name}
                <hr style={{ width: "80%", margin: "0 auto 5px", border: "0", borderTop: "1px solid black" }} />
                Пословно име послодавca
              </div>
              <div style={{ width: "33%", textAlign: "center" }}>
                {companyHeader.address}
                <hr style={{ width: "80%", margin: "0 auto 5px", border: "0", borderTop: "1px solid black" }} />
                Адреса седишта послодавца
              </div>
              <div style={{ width: "33%", textAlign: "center" }}>
                {companyHeader.pib}
                <hr style={{ width: "80%", margin: "0 auto 5px", border: "0", borderTop: "1px solid black" }} />
                ПИБ послодавца
              </div>
            </div>

            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={cs}>Редни број</th>
                  <th style={cs}>Назив радног места на коме је запослени радио када се догодила повреда</th>
                  <th style={cs}>Име и презиме повређеног</th>
                  <th style={cs}>Време настанка повреде на раду (датум, дан у седмици, час)</th>
                  <th style={cs}>Врста повреде (појединачна или колективна)</th>
                  <th style={cs}>Оцена тежине повреде (лака, тешка, смртна повреда на раду)</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, i) => (
                  <tr key={item.id}>
                    <td style={cs}>{i + 1}.</td>
                    <td style={{ ...cs, textAlign: "left" }}>{item.workplace_name}</td>
                    <td style={cs}>{item.ime_prezime}</td>
                    <td style={cs}>{item.datum_povrede}</td>
                    <td style={cs}>{item.vrsta}</td>
                    <td style={cs}>{item.ocena}</td>
                  </tr>
                ))}
                {data.length === 0 && (
                  <tr>
                    {Array.from({ length: 6 }).map((_, i) => <td key={i} style={cs}></td>)}
                  </tr>
                )}
              </tbody>
            </table>

            <br /><br />
            <div style={{ display: "flex" }}>
              <div style={{ width: "70%", textAlign: "center" }}>
                <hr style={{ width: "80%", margin: "0 auto 5px", border: "0", borderTop: "1px solid black" }} />
                Саветник/сарадник за безбедност и здравље на раду
              </div>
              <div style={{ width: "30%", textAlign: "center" }}>
                <hr style={{ width: "80%", margin: "0 auto 5px", border: "0", borderTop: "1px solid black" }} />
                Послодавац
              </div>
            </div>
          </div>

          <div style={{ marginTop: "15px", padding: "10px" }}>
            {isDodavanje ? (
              <EvidencijeObrazac2Dodavanje
                setIsDodavanje={setIsDodavanje}
                onRefresh={fetchData}
              />
            ) : (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex", gap: "10px" }}>
                  <div onClick={handleStampaj}>
                    <Button activation={true} style={styles.button}>ШТАМПАЈ</Button>
                  </div>
                  <div>
                    <Button activation={true} style={styles.button}>ПОШАЉИ</Button>
                  </div>
                </div>
                <div onClick={() => setIsDodavanje(true)}>
                  <Button activation={true} style={styles.button}>ДОДАЈ</Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default EvidencijeObrazac2;